package redux

/**
 * The order date
 */
enum class FeedbackState {
  /**
   * No server communication yet - the user is entering the data
   */
  EnteringData,

  /**
   * The order has been sent to the server, waiting for response
   */
  FeedbackSent,

  /**
   * The order has been processed by the server
   */
  FeedbackSuccess,

  /**
   * The order has failed - the server has returned an error or not answered at all
   */
  FeedbackFailed,
}
